(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coleccion-por-colores"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('lua-color-collection-v3')) return;
  class LuaColorCollection extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.grid = this.querySelector('[data-products-grid]');
        this.cards = Array.from(this.querySelectorAll('.product-card'));
        this.editorials = Array.from(this.querySelectorAll('[data-editorial-banner]'));
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        this.sort = 'relevance';
        this.colors = [];
        this.sizes = [];
        this.timers = new Set();
        this.cards.forEach(card => this.initCard(card, signal));
        this.dataset.enhanced = 'true';
        this.applyView();
        this.sortSizeFilters();
        this.addEventListener('click', event => this.onClick(event), { signal });
        this.addEventListener('keydown', event => this.onKeydown(event), { signal });
        this.addEventListener('error', event => {
          const image = event.target;
          if (!(image instanceof HTMLImageElement)) return;
          const fallback = image.dataset.fallbackSrc;
          delete image.dataset.fallbackSrc;
          if (fallback && image.getAttribute('src') !== fallback) image.src = fallback;
        }, { capture: true, signal });
        window.addEventListener('resize', () => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => {
            this.closePanels(false);
            this.cards.forEach(card => this.setSlide(card, 0));
            this.applyView();
          });
        }, { signal });
      });
    }

    disconnectedCallback() {
      this.closePanels(false);
      this.controller?.abort();
      this.controller = null;
      cancelAnimationFrame(this.resizeFrame);
      this.timers?.forEach(clearTimeout);
    }

    normalizeSize(value) {
      const text = String(value || '').trim().replace(/\s+/g, ' ');
      return ['talla unica', 'talla única', 'unica', 'única', 'one size', 'onesize', 'u', 'tu'].includes(text.toLowerCase()) ? 'Talla única' : text;
    }

    sortSizeFilters() {
      const order = ['talla única', 'xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl', 's/m', 'm/l', 'l/xl'];
      const list = this.querySelector('input[data-filter-type="size"]')?.closest('.filter-group__list');
      if (!list) return;
      const rank = value => {
        const index = order.indexOf(this.normalizeSize(value).toLowerCase());
        return index < 0 ? 100 : index;
      };
      Array.from(list.children).sort((a, b) => rank(a.querySelector('input').value) - rank(b.querySelector('input').value)).forEach(item => list.appendChild(item));
    }

    initCard(card, signal) {
      let variants = [];
      try { variants = JSON.parse(card.dataset.productVariants || '[]'); } catch (_) {}
      const sizeIndex = card.hasAttribute('data-size-index') ? Number(card.dataset.sizeIndex) : null;
      card.querySelectorAll('[data-size-button]').forEach(button => {
        const choices = variants.filter(variant => sizeIndex === null || this.normalizeSize(variant[2][sizeIndex]) === this.normalizeSize(button.dataset.sizeValue));
        const choice = choices.find(variant => variant[1]) || choices[0];
        const available = Boolean(choice && choice[1]);
        button.disabled = false;
        button.classList.remove('is-loading', 'is-added');
        const label = button.querySelector('.size-button__text');
        if (label) label.textContent = button.dataset.sizeValue;
        button.classList.toggle('is-disabled', !available);
        button.dataset.soldOut = String(!available);
        button.dataset.chooseOptions = String(choices.length > 1);
        if (choice) button.dataset.variantId = String(choice[0]);
        button.title = available ? button.dataset.sizeValue : this.dataset.soldOut;
      });
      const carousel = card.querySelector('[data-carousel]');
      if (!carousel) return;
      card.addEventListener('mouseenter', () => {
        if (window.innerWidth >= 750) this.setSlide(card, 1);
      }, { signal });
      card.addEventListener('mouseleave', () => {
        if (window.innerWidth >= 750) this.setSlide(card, 0);
      }, { signal });
      card.addEventListener('focusin', () => {
        if (window.innerWidth >= 750) this.setSlide(card, 1);
      }, { signal });
      card.addEventListener('focusout', event => {
        if (!card.contains(event.relatedTarget)) this.setSlide(card, 0);
      }, { signal });
      let start = null;
      carousel.addEventListener('touchstart', event => {
        if (window.innerWidth >= 750 || event.touches.length !== 1) return;
        start = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }, { passive: true, signal });
      carousel.addEventListener('touchend', event => {
        if (!start || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - start.x;
        const dy = event.changedTouches[0].clientY - start.y;
        start = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          this.setSlide(card, dx < 0 ? 1 : 0);
          card._suppressClickUntil = Date.now() + 450;
        }
      }, { passive: true, signal });
      carousel.addEventListener('touchcancel', () => { start = null; }, { signal });
      carousel.addEventListener('click', event => {
        if (Date.now() < (card._suppressClickUntil || 0)) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, { capture: true, signal });
    }

    setSlide(card, index) {
      const slides = Array.from(card.querySelectorAll('[data-carousel-slide]'));
      const track = card.querySelector('[data-carousel-track]');
      if (!track || !slides.length) return;
      const selected = Math.min(Math.max(index, 0), slides.length - 1);
      track.style.transform = window.innerWidth < 750 ? 'translate3d(-' + selected * 100 + '%,0,0)' : '';
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === selected && i > 0);
        slide.classList.toggle('is-inactive', i !== selected && i > 0);
        slide.setAttribute('aria-hidden', String(i !== selected));
      });
    }

    applyView() {
      if (!this.grid) return;
      const cards = [...this.cards].sort((a, b) => {
        const priceDifference = Number(a.dataset.productPrice) - Number(b.dataset.productPrice);
        if (this.sort === 'price-asc' && priceDifference) return priceDifference;
        if (this.sort === 'price-desc' && priceDifference) return -priceDifference;
        return Number(a.dataset.productPosition) - Number(b.dataset.productPosition);
      });
      let visibleCount = 0;
      const fragment = document.createDocumentFragment();
      const parkedEditorials = document.createDocumentFragment();
      const insertAfter = editorial => Number(window.innerWidth < 750 ? editorial.dataset.mobileInsertAfter : editorial.dataset.desktopInsertAfter);
      const editorials = [...this.editorials].sort((a, b) => {
        const positionDifference = insertAfter(a) - insertAfter(b);
        if (positionDifference) return positionDifference;
        return Number(a.dataset.editorialPosition) - Number(b.dataset.editorialPosition);
      });
      editorials.forEach(editorial => {
        editorial.hidden = true;
        parkedEditorials.appendChild(editorial);
      });
      let editorialIndex = 0;
      while (editorialIndex < editorials.length && insertAfter(editorials[editorialIndex]) <= 0) {
        const editorial = editorials[editorialIndex];
        editorial.hidden = false;
        fragment.appendChild(editorial);
        editorialIndex++;
      }
      cards.forEach(card => {
        const cardSizes = (card.dataset.sizes || '').split('|').filter(Boolean).map(value => this.normalizeSize(value));
        const visible = (!this.colors.length || this.colors.includes(card.dataset.colorValue)) &&
          (!this.sizes.length || this.sizes.some(size => cardSizes.includes(size)));
        card.classList.toggle('is-hidden', !visible);
        if (visible) visibleCount++;
        card.classList.toggle('is-mosaic-wide', window.innerWidth < 750 && visible && visibleCount % 3 === 0);
        fragment.appendChild(card);
        while (visible && editorialIndex < editorials.length && insertAfter(editorials[editorialIndex]) <= visibleCount) {
          const editorial = editorials[editorialIndex];
          editorial.hidden = false;
          fragment.appendChild(editorial);
          editorialIndex++;
        }
      });
      while (editorialIndex < editorials.length) {
        fragment.appendChild(editorials[editorialIndex]);
        editorialIndex++;
      }
      this.grid.appendChild(fragment);
      this.querySelector('[data-results-empty]')?.classList.toggle('is-visible', visibleCount === 0);
      this.querySelectorAll('[data-sort-value]').forEach(button => {
        const active = button.dataset.sortValue === this.sort;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    }

    readFilters() {
      this.colors = Array.from(this.querySelectorAll('[data-filter-type="color"]:checked'), input => input.value.trim());
      this.sizes = Array.from(this.querySelectorAll('[data-filter-type="size"]:checked'), input => this.normalizeSize(input.value));
    }

    closePanels(restoreFocus = true) {
      this.panels?.forEach(panel => {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
        panel.inert = true;
        panel.style.removeProperty('top');
        panel.style.removeProperty('max-height');
      });
      this.querySelectorAll('[data-open-panel]').forEach(button => {
        button.classList.remove('is-active');
        button.setAttribute('aria-expanded', 'false');
      });
      this.querySelector('[data-dropdown-overlay]')?.classList.remove('is-visible');
      if (this.scrollStyles) {
        Object.assign(document.body.style, this.scrollStyles);
        document.documentElement.style.overflow = this.htmlOverflow;
        this.scrollStyles = null;
        window.scrollTo(0, this.scrollY);
      }
      if (restoreFocus && this.panelTrigger?.isConnected) this.panelTrigger.focus({ preventScroll: true });
      this.panelTrigger = null;
    }

    openPanel(button) {
      const panel = this.panels.find(item => item.dataset.panel === button.dataset.openPanel);
      if (!panel) return;
      const wasOpen = panel.classList.contains('is-open');
      this.closePanels(false);
      if (wasOpen) return;
      this.panelTrigger = button;
      if (window.innerWidth < 750) {
        this.scrollY = window.scrollY;
        this.htmlOverflow = document.documentElement.style.overflow;
        this.scrollStyles = {};
        ['position', 'top', 'left', 'right', 'width', 'overflow'].forEach(key => { this.scrollStyles[key] = document.body.style[key]; });
        Object.assign(document.body.style, { position: 'fixed', top: -this.scrollY + 'px', left: '0', right: '0', width: '100%', overflow: 'hidden' });
        document.documentElement.style.overflow = 'hidden';
        const top = Math.min(button.getBoundingClientRect().bottom + 10, window.innerHeight * 0.3);
        panel.style.setProperty('top', top + 'px');
        panel.style.setProperty('max-height', Math.max(140, window.innerHeight - top - 12) + 'px', 'important');
      }
      panel.inert = false;
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      button.classList.add('is-active');
      button.setAttribute('aria-expanded', 'true');
      this.querySelector('[data-dropdown-overlay]')?.classList.add('is-visible');
      panel.querySelector('button, input')?.focus({ preventScroll: true });
    }

    onKeydown(event) {
      const panel = this.panels.find(item => item.classList.contains('is-open'));
      if (!panel) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.closePanels();
      }
      if (event.key === 'Tab') {
        const focusable = Array.from(panel.querySelectorAll('button:not(:disabled), input:not(:disabled), a[href]'));
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first?.focus();
        }
      }
    }

    async addToCart(button) {
      if (button.disabled || !button.dataset.variantId) return;
      button.disabled = true;
      button.classList.add('is-loading');
      const label = button.querySelector('.size-button__text');
      const drawer = document.querySelector('cart-drawer, cart-notification');
      const root = window.Shopify?.routes?.root || '/';
      const payload = { items: [{ id: Number(button.dataset.variantId), quantity: 1 }] };
      const sections = typeof drawer?.getSectionsToRender === 'function' ? drawer.getSectionsToRender() : [];
      if (sections.length) {
        payload.sections = sections.map(section => section.id).slice(0, 5);
        payload.sections_url = window.location.pathname;
      }
      let cartData;
      try {
        const response = await fetch(window.routes?.cart_add_url || root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        cartData = await response.json();
        if (!response.ok || cartData.status >= 400) throw new Error(cartData.description || this.dataset.addError);
      } catch (error) {
        button.disabled = false;
        button.classList.remove('is-loading');
        alert(error.message || this.dataset.addError);
        return;
      }
      button.classList.remove('is-loading');
      button.classList.add('is-added');
      if (label) label.textContent = this.dataset.addedLabel;
      const status = this.querySelector('[data-cart-status]');
      if (status) status.textContent = this.dataset.addedLabel;
      try {
        if (typeof drawer?.renderContents === 'function' && cartData.sections) {
          drawer.setActiveElement?.(button);
          drawer.classList.remove('is-empty');
          drawer.renderContents({ ...cartData, id: cartData.id || cartData.items?.[0]?.id });
        }
      } catch (_) {}
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cartData }));
      document.dispatchEvent(new CustomEvent('cart:update', { detail: cartData }));
      const timer = setTimeout(() => {
        button.disabled = false;
        button.classList.remove('is-added');
        if (label) label.textContent = button.dataset.sizeValue;
        this.timers.delete(timer);
      }, 1400);
      this.timers.add(timer);
    }

    onClick(event) {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      const open = target.closest('[data-open-panel]');
      if (open) { event.preventDefault(); this.openPanel(open); return; }
      if (target.closest('[data-close-panels], [data-dropdown-overlay]')) {
        event.preventDefault(); this.closePanels(); return;
      }
      const sortButton = target.closest('[data-sort-value]');
      if (sortButton) {
        this.sort = sortButton.dataset.sortValue;
        this.applyView(); this.closePanels(); return;
      }
      if (target.closest('[data-clear-filters]')) {
        this.querySelectorAll('[data-filter-type]').forEach(input => { input.checked = false; });
        this.readFilters(); this.applyView(); return;
      }
      if (target.closest('[data-apply-filters]')) {
        this.readFilters(); this.applyView(); this.closePanels(); return;
      }
      const sizeButton = target.closest('[data-size-button]');
      if (!sizeButton || sizeButton.disabled) return;
      event.preventDefault();
      if (sizeButton.dataset.soldOut === 'true' || sizeButton.dataset.chooseOptions === 'true') {
        const card = sizeButton.closest('.product-card');
        const url = new URL(card.dataset.productUrl, window.location.origin);
        if (sizeButton.dataset.variantId) url.searchParams.set('variant', sizeButton.dataset.variantId);
        window.location.assign(url.href);
        return;
      }
      this.addToCart(sizeButton);
    }
  }
  customElements.define('lua-color-collection-v3', LuaColorCollection);
})();



  } catch(e) { console.error(e); }
})();
})();
